import request from '@/utils/request'

export function fetchCardBatchList (query) {
  return request({
    url: '/card/api/card_batch/index',
    method: 'get',
    params: query
  })
}

export function fetchCardBatch (id) {
  return request({
    url: '/card/api/card_batch/view',
    method: 'get',
    params: { id }
  })
}

export function createCardBatch (data) {
  return request({
    url: '/card/api/card_batch/insert',
    method: 'post',
    data
  })
}

export function updateCardBatch (id, data) {
  return request({
    url: '/card/api/card_batch/update',
    method: 'post',
    params: { id },
    data
  })
}

export function deleteCardBatch (id) {
  return request({
    url: '/card/api/card_batch/delete',
    method: 'post',
    params: { id }
  })
}

export function batchCards (id, page, limit) {
  return request({
    url: '/card/api/card_batch/cards',
    method: 'get',
    params: {id: id, page: page, limit: limit}
  })
}

export function batchUpdateKind (id, kind) {
  return request({
    url: '/card/api/card_batch/kind',
    method: 'post',
    params: {id, kind}
  })
}
export function batchUpdateCatelog (id, catelog) {
  return request({
    url: '/card/api/card_batch/catelog',
    method: 'post',
    params: {id, catelog}
  })
}
export function batchUpdateSupplier (id, supplierId) {
  return request({
    url: '/card/api/card_batch/supplier_update',
    method: 'post',
    params: {id, supplierId}
  })
}
export function batchUpdateGroup (id, group) {
  return request({
    url: '/card/api/card_batch/group',
    method: 'post',
    params: {id, group}
  })
}
export function batchProductAdd (id, product) {
  return request({
    url: '/card/api/card_batch/batchPackageAdd',
    method: 'post',
    params: {id, product_id: product}
  })
}
export function exportApply (query) {
  return request({
    url: '/card/api/card_batch/export',
    method: 'get',
    params: query
  })
}
export function batchMonitor (id) {
  return request({
    url: '/card/api/card_batch/batchMonitor',
    method: 'post',
    params: {id}
  })
}



// WEBPACK FOOTER //
// ./src/card/api/card-batch.js